export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/680273bf09bfd3a8fc34474ae0d0eb37.svg";